import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}
export default async function getPlotData(code) {
  let queryStr = '';
  // let code = "FUNDS1067983_AAPL_SHR";
  let _code = code.replace(/[\.\@\|\$\^\:]/g, '_');
  const data = await fetchAPI(`
      query{
        ${_code}: getData(code: "${code}") {
          type: __typename
          ... on Series_Data {
            code: seriesCode
            # source
            # desc: seriesDescription
            # abbr: shortName
            value
            recordDate
            # rn
          }
          ... on Stock_Data {
            code: seriesCode
            # source
            # description
            # short_name
            price
            record_date
            rn
          }
          ... on Seq_Series_Data {
            code: seriesCode
            seq
            value
            # desc
            # source
          }
        }
      }
    `,
  )
  return data
}
